<template>
  <div>
    <v-container v-if="!loading">
      <div class="float-right">
        <v-btn class="rounded-xl ml-2" text to="/autoCollect/settings">
          <v-icon>mdi-cog</v-icon>&nbsp;Configure AutoCollect
        </v-btn>
      </div>
      <br /><br />
      <div v-if="!autoCollections.length" class="justify-center text-center">
        <v-icon size="120" color="#606060"> mdi-tooltip-check </v-icon>
        <h1 style="opacity: 0.7">You have no pending approvals!</h1>
        <p style="opacity: 0.7">
          You may configure AutoCollect with the button in the corner.
        </p>
      </div>
      <v-row v-if="autoCollections.length">
        <v-col
          v-for="item in autoCollections"
          :key="'item-' + item.id + '-' + (item.shared ? 'shared' : 'owned')"
          md="4"
        >
          <v-card
            :loading="loading"
            class="rounded-xl d-flex flex-column"
            elevation="8"
            style="cursor: pointer"
            :to="'/autoCollect/' + item.id"
          >
            <v-img
              :src="collectionImage(item)"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.0)"
              height="200px"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
              <v-card-title>
                {{ item.name }}
                <v-spacer></v-spacer>
                <small
                  >{{ item.autoCollectApprovals.length }} pending
                  approvals</small
                >
              </v-card-title>
              <v-card-subtitle v-if="!item.shared && item.users.length">
                <v-icon> mdi-swap-horizontal </v-icon>
                Shared with {{ item.users.length }} others.
              </v-card-subtitle>
              <v-card-subtitle v-if="item.shared && item.user">
                <v-icon> mdi-swap-horizontal </v-icon>
                Shared with me by {{ item.user.username }}
                <v-chip
                  style="padding: 5px"
                  x-small
                  color="dark"
                  v-if="item.recipient.write"
                  >WRITE</v-chip
                >
              </v-card-subtitle>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <small> Total Items: {{ autoCollections.length }} </small>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <v-card class="rounded-xl" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"

export default {
  name: "AutoCollect",
  data() {
    return {
      autoCollections: [],
      loading: true
    }
  },
  methods: {
    collectionImage(item) {
      if (item?.preview?.attachment) {
        return "/i/" + item.preview.attachment.attachment
      } else {
        return "https://i.troplo.com/i/a050d6f271c3.png"
      }
    },
    getAutoCollections() {
      this.loading = true
      this.axios
        .get("/api/v1/autoCollect")
        .then((res) => {
          this.loading = false
          this.autoCollections = res.data
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getAutoCollections()
  }
}
</script>

<style scoped></style>
